import React, { useEffect } from 'react';
import './oficiniavirtualproveedor.css';

const OficinaVirtualProveedor = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container transparencia-container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h1 className='title'>Proveedores</h1>
          <hr className='hr-gob'/>
        </div>

        <div className='col-md-6 col-12 ofiprov-card'>
          <img src="/assets/imgs/oficina_virtual/Inscrip.Prove..png" alt="Inscripción" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Inscripción en el padrón de Proveedores del Estado de Hidalgo</h2>
          <div className='ofiprov-links'>
             <a href="https://esit.hidalgo.gob.mx/eSIT/oficinaVirtual/P1_mov_padron/oficina_virtual/c_oficina_virtual_ss.jsp?cve_ruts=SC/SC/332" target="_blank" rel="noopener noreferrer" 
            className='btn-oficina'>Ir al Servicio</a>
            
            <a href="https://ruts.hidalgo.gob.mx/ver/384" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--gold'>Video Tutorial</span>
          </div>
        </div>
        

        <div className='col-md-6 col-12 ofiprov-card'>
          <img src="/assets/imgs/oficina_virtual/Act.Datos.png" alt="Modificación" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Modificación en el padrón de Proveedores del Estado de Hidalgo</h2>
          <div className='ofiprov-links'>

          <a href="https://esit.hidalgo.gob.mx/eSIT/oficinaVirtual/P1_mov_padron/oficina_virtual/c_oficina_virtual_ss.jsp?cve_ruts=SC/SC/388" target="_blank" rel="noopener noreferrer" 
            className='btn-oficina'>Ir al Servicio</a>

            <a href="https://ruts.hidalgo.gob.mx/ver/10913" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--gold'>Video Tutorial</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OficinaVirtualProveedor;
